// Ported verbatim from WOOF1_eCRF_v7.html (source line 2268).
// Returns null if valid, or a human-readable French error message otherwise.
export function validatePasswordStrength(pwd: string | null | undefined): string | null {
  if (!pwd || pwd.length < 10) return "Le mot de passe doit faire au moins 10 caractères";
  if (!/[A-Z]/.test(pwd)) return "Le mot de passe doit contenir au moins 1 majuscule";
  if (!/[a-z]/.test(pwd)) return "Le mot de passe doit contenir au moins 1 minuscule";
  if (!/[0-9]/.test(pwd)) return "Le mot de passe doit contenir au moins 1 chiffre";
  if (!/[^A-Za-z0-9]/.test(pwd)) return "Le mot de passe doit contenir au moins 1 caractère spécial";
  return null;
}
